"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderSidebar = void 0;
var ProviderSidebar_1 = require("./ProviderSidebar");
Object.defineProperty(exports, "ProviderSidebar", { enumerable: true, get: function () { return __importDefault(ProviderSidebar_1).default; } });
//# sourceMappingURL=index.js.map